// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"906eaa82","453":"ee76f48b","551":"c5b50be6","640":"1b2787d2"}[chunkId] + ".chunk.js";
};